import { inIframe } from '@teko/utils';
import { isServerless } from './index';
import { BrowserEnv } from '../libs';

const getCookieByName = (cname: string) => {
  const match = document.cookie.match(new RegExp('(^| )' + cname + '=([^;]+)'));
  if (match) return match[2];
  return null;
};

export const getEnv = (
  variable: keyof (BrowserEnv & NodeJS.ProcessEnv),
  defaultValue?: number | string,
) => {
  if (typeof window === 'undefined') {
    return process.env[variable];
  }
  return window.env?.[variable as keyof BrowserEnv] || defaultValue;
};

/**
 * For some tenant, there are multiple terminal codes (Nam, Bac, Trung ...)
 * Let user select the corresponding terminal
 * save it to localStorage and cookie
 */

export const getUserSelectedInfo = (key: string, isMobile = false) => {
  if (typeof window !== 'undefined' && key) {
    // for backward compatible
    const cookieKey = isMobile ? `${key}_mobile` : key;
    const lsKey = isMobile ? `${key.toUpperCase()}_mobile` : key.toUpperCase();
    const dataLS = window.localStorage.getItem(lsKey);
    const dataCookie = getCookieByName(cookieKey);

    // https://jira.teko.vn/browse/CSFRONT-649
    // due Safari not allowing cookie in iframe
    // we will load data from local storage instead
    // and accept that location & terminal of SSR differs from
    // that being stored in localStorage.
    // For vnshop, vietin... there is only one terminal and multiple locations
    // so that won't cause many trouble.
    if (inIframe()) {
      // check if it's in iframe
      // we don't want to affect existing logic
      return dataCookie || dataLS;
    }
    return dataCookie && dataLS === dataCookie ? dataCookie : null;
  }
  return null;
};

export const setUserSelectedInfo = (
  key: string,
  value: string,
  isMobile = false,
) => {
  if (typeof window !== 'undefined' && key) {
    // for backward compatible
    const cookieKey = isMobile ? `${key}_mobile` : key;
    const lsKey = isMobile ? `${key.toUpperCase()}_mobile` : key.toUpperCase();
    window.localStorage.setItem(lsKey, value);
    document.cookie = `${cookieKey}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;`;

    const isHttps = window.location.protocol === 'https:';
    const date = new Date();
    date.setFullYear(date.getFullYear() + 2);
    document.cookie = `${cookieKey}=${value};expires=${date.toUTCString()};Path=/;${
      isHttps ? 'SameSite=None;Secure;' : ''
    }`;
  }
};

export const removeUserSelectedInfo = (key: string, isMobile = false) => {
  if (typeof window !== 'undefined' && key) {
    // for backward compatible
    const cookieKey = isMobile ? `${key}_mobile` : key;
    const lsKey = isMobile ? `${key.toUpperCase()}_mobile` : key.toUpperCase();
    window.localStorage.removeItem(lsKey);
    const isHttps = window.location.protocol === 'https:';
    const date = new Date();
    date.setFullYear(date.getFullYear() + 2);
    document.cookie = `${cookieKey}=;expires=${date.toUTCString()};Path=/;${
      isHttps ? 'SameSite=None;Secure;' : ''
    }`;
  }
};

export const setSessionStorageIfNotExist = (key: string, value: string) => {
  if (isServerless() && !sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, value);
  }
};
